'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadProjectImage = uploadProjectImage;

var _promise = require('promise');

var _promise2 = _interopRequireDefault(_promise);

require('isomorphic-fetch');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* injects from baggage-loader */

/* eslint no-unused-vars: 0*/


var BUCKET_PATH = 'naissur-hello-bucket/projects-share-images'; // polyfilling Promise

var getProjectUrl = function getProjectUrl(projectKey) {
  return 'https://s3.amazonaws.com/' + BUCKET_PATH + '/' + projectKey;
};

function uploadProjectImage(_ref) {
  var projectId = _ref.projectId;
  var base64Data = _ref.base64Data;

  var strippedImageData = base64Data.split('base64,')[1];
  var buf = new Buffer(strippedImageData, 'base64');

  var prefix = new Date().getTime().toString() + Math.random().toString();
  var projectKey = prefix + '-' + projectId + '.png'; // add prefix to avoid facebook caching

  var projectUrl = getProjectUrl(projectKey);

  return fetch(projectUrl, {
    headers: {
      'Content-Type': 'image/png',
      'Content-Encoding': 'base64',
      'x-amz-acl': 'public-read'
    },
    method: 'put',
    body: buf
  }).then(function () {
    return projectUrl;
  });
}


//////////////////
// WEBPACK FOOTER
// ./app/utils/s3.js
// module id = 643
// module chunks = 1